module.exports = __webpack_public_path__ + "img/cat-icon.25504046.svg";